export const HEAP_APP_ID = '1849740842';
export const HEAP_ENVS = ['payment.flywire.com'];
